import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { fetchFreshLeadsV2Data } from "../../../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import {
  BinIcon1,
  CalendarIcon,
  EditIcon1,
} from "../../../../images/icons/icons";

const CustomerTypeBreakdown = ({ stats, userInfoData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modData, setModData] = useState(null);
  const [freshLeadsPage, setFreshLeadsPage] = useState(0);
  const [freshLeadsPageLimit, setFreshLeadsPageLimit] = useState(10);

  const dispatch = useDispatch();
  const { freshLeadsV2, freshLeadsV2Loading } = useSelector(
    (state) => state?.prospects
  );

  // Reusable table columns configuration for all lead types
  const leadsTableColumns = [
    {
      dataField: "lead_info",
      text: "LEAD INFO",
      formatter: (_, row) => (
        <div className="d-flex align-items-center minWidth150">
          <div>
            <div
              style={{ cursor: "pointer" }}
              className="text-start ps-1 text-primary"
            >
              {row?.name || "N/A"}
            </div>
            <div className="d-flex align-items-center mt-1">
              <i className="fas fa-phone me-1 text-muted"></i>
              <span className="text-muted small">{row?.mobile || "N/A"}</span>
            </div>
            <div className="d-flex align-items-center mt-1">
              <i className="fas fa-envelope me-1 text-muted"></i>
              <span className="text-muted small">{row?.email || "N/A"}</span>
            </div>
            <div className="d-flex align-items-center mt-1">
              <i className="fas fa-th me-1 text-muted"></i>
              <button
                className="btn btn-sm btn-primary py-1 px-1 rounded-pill"
                style={{ fontSize: "10px" }}
              >
                {row?.mem_lead_stage?.toUpperCase() || "PENDING"}
              </button>
            </div>
          </div>
        </div>
      ),
    },
    {
      dataField: "lead_status",
      text: "LEAD STATUS",
      formatter: (_, row) => (
        <div className="maxWidth120">
          <span
            className={`badge ${
              row?.lead_status === "converted" ? "bg-success" : "bg-warning"
            }`}
          >
            {row?.lead_status || "Pending"}
          </span>
        </div>
      ),
    },
    {
      dataField: "followup_stage",
      text: "CURRENT FOLLOWUP STAGE",
      formatter: (_, row) => (
        <div className="minWidth200">
          <div>{row?.followup_days_count || "0"}</div>
          <div className="text-success small">
            {row?.followup_number || "0"} Time(S)
          </div>
        </div>
      ),
    },
    {
      dataField: "last_followup",
      text: "LAST FOLLOWUP STATUS",
      formatter: (_, row) => (
        <div className="minWidth150">
          <div>{row?.current_followup_status || "N/A"}</div>
          <div className="text-success small">
            {row?.cutomer_intent || "N/A"}
          </div>
          <div className="text-muted small">
            Next: {row?.next_followup_date || "N/A"}
          </div>
          <div className="text-muted small">
            Assigned To -{" "}
            <span className="text-primary" style={{ cursor: "pointer" }}>
              {row?.assigned_to_name || "N/A"}
            </span>
          </div>
        </div>
      ),
    },
    {
      dataField: "value",
      text: "VALUE (₹)",
      formatter: (_, row) => (
        <div className="minWidth150">
          <div className="">₹{row?.lead_value || "0"}</div>
          <div className="text-muted small">
            Plan: {row?.plan_type || "Undefined"}
          </div>
          <div className="text-muted small">
            Converted @{" "}
            <span className="text-success">₹{row?.converted_value || "0"}</span>
          </div>
        </div>
      ),
    },
    {
      dataField: "source_branch",
      text: "SOURCE & BRANCH",
      formatter: (_, row) => (
        <div className="minWidth150">
          <div className="">{row?.gym_name || "N/A"}</div>
          <div className="text-muted small">{row?.source_name || "N/A"}</div>
          <div className="text-muted small">
            Added By -{" "}
            <span className="text-primary" style={{ cursor: "pointer" }}>
              {row?.added_by_name || "N/A"}
            </span>
          </div>
        </div>
      ),
    },
    // {
    //   dataField: "quick_actions",
    //   text: "QUICK ACTIONS",
    //   formatter: (_, row) => (
    //     <div className="d-flex gap-4 minWidth150 ">
    //       <button className="btn btn-outline-danger btn-sm p-1" style={{ width: '30px', height: '30px' }}>
    //       <EditIcon1></EditIcon1>
    //       </button>
    //       <button className="btn btn-outline-danger btn-sm p-1" style={{ width: '30px', height: '30px' }}>
    //        <CalendarIcon/>
    //       </button>
    //       <button className="btn btn-outline-danger btn-sm p-1" style={{ width: '30px', height: '30px' }}>
    //       <BinIcon1 />
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  // Get lead stage based on customer type
  const getLeadStage = (customerType) => {
    const stageMap = {
      "Fresh Leads": "fresh",
      "Renewal Leads": "renewal",
      "Unpaid Leads": "expired",
      "Subscribed Leads": "subscribed",
    };
    return stageMap[customerType] || "fresh";
  };

  // Generic page change handler for all lead types
  const handleLeadsPageChange = (newPage) => {
    setFreshLeadsPage(newPage);
    if (modData?.type) {
      dispatch(
        fetchFreshLeadsV2Data({
          filters: {
            page: newPage + 1,
            limit: freshLeadsPageLimit,
            mem_lead_stage: getLeadStage(modData.type),
          },
          token: userInfoData?.token,
        })
      );
    }
  };

  const handleLeadsPageLimitChange = (newLimit) => {
    setFreshLeadsPageLimit(newLimit);
    if (modData?.type) {
      dispatch(
        fetchFreshLeadsV2Data({
          filters: {
            page: 1,
            limit: newLimit,
            mem_lead_stage: getLeadStage(modData.type),
          },
          token: userInfoData?.token,
        })
      );
    }
  };

  const customerTypes = [
    {
      type: "Fresh Leads",
      description: "New potential members",
      count: stats?.fresh_leads || "0",
      color: "green",
    },
    {
      type: "Renewal Leads",
      description: "Existing member renewals",
      count: stats?.renewal_leads || "0",
      color: "blue",
    },
    {
      type: "Unpaid Leads",
      description: "Win-back campaigns",
      count: stats?.expired_leads || "0",
      color: "orange",
    },
    {
      type: "Subscribed Leads",
      description: "Win-back campaigns",
      count: stats?.subscribed_leads || "0",
      color: "purple",
    },
  ];

  const handleCustomerTypeClick = (customerType) => {
    setModData(customerType);
    setIsModalOpen(true);
    setFreshLeadsPage(0);
    setFreshLeadsPageLimit(10);
    dispatch(
      fetchFreshLeadsV2Data({
        filters: {
          page: 1,
          limit: 10,
          mem_lead_stage: getLeadStage(customerType.type),
        },
        token: userInfoData?.token,
      })
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setModData(null);
    }, 300);
  };

  console.log("freshLeadsV2==>", freshLeadsV2);

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Customer Type Details Modal"
        ariaHideApp={false}
        closeTimeoutMS={300}
      >
        <div
          className="modal-body-k container rounded-4 bg-white"
          style={{ maxWidth: "95vw", width: "95vw" }}
        >
          <ModalHeadAndClose
            title={
              modData ? `${modData.type} Details` : "Customer Type Details"
            }
            onClose={handleCloseModal}
          />

          {/* Display API data for all lead types */}
          {modData?.type && (
            <div>
              {freshLeadsV2Loading && (
                <div>
                  <ReactVortoxSpinner />
                </div>
              )}
              {freshLeadsV2 && freshLeadsV2.status && (
                <div>
                  {freshLeadsV2.data && freshLeadsV2.data.length > 0 && (
                    <div className="fullWidthFlexCenter overflowAuto separatedTable ">
                      <div
                        className="table-responsive"
                        style={{ border: "1px solid #dee2e6" }}
                      >
                        <PaymentLinkTable
                          tableData={freshLeadsV2.data}
                          tableColumns={leadsTableColumns}
                          tablePagination={freshLeadsV2.pagination || []}
                          isPage={freshLeadsPage}
                          setIsPage={handleLeadsPageChange}
                          pageLimit={freshLeadsPageLimit}
                          setPageLimit={handleLeadsPageLimitChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
      <div className="lms-closure-customer-breakdown-card">
        <div className="lms-closure-customer-breakdown-header">
          <h3 className="lms-closure-customer-breakdown-title">
            Customer Type Breakdown
          </h3>
          <p className="lms-closure-customer-breakdown-subtitle">
            Lead distribution by customer category
          </p>
        </div>
        <div className="lms-closure-customer-breakdown-body">
          <div className="lms-closure-customer-breakdown-items">
            {customerTypes.map((item, index) => (
              <div
                key={index}
                className={`lms-closure-customer-breakdown-item lms-closure-customer-${item.color}`}
                onClick={() => handleCustomerTypeClick(item)}
              >
                <div className="lms-closure-customer-breakdown-left">
                  <p className="lms-closure-customer-breakdown-name">
                    {item.type}
                  </p>
                  <p className="lms-closure-customer-breakdown-description">
                    {item.description}
                  </p>
                </div>
                <div className="lms-closure-customer-breakdown-right">
                  <p className="lms-closure-customer-breakdown-count">
                    {item.count}
                  </p>
                  <p
                    className={`lms-closure-customer-breakdown-change lms-closure-customer-${item.color}-text`}
                  >
                    {item.change}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerTypeBreakdown;
